import React, { useState, useEffect } from "react"
import * as styles from "./cookieSettings.module.scss"
import {CookieConsent as CookieBanner} from "react-cookie-consent"
import { Cookies, getCookieConsentValue } from "react-cookie-consent"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import { initializeAndTrack } from "@spencerwhyte/gatsby-plugin-gdpr-cookies"
import { useLocation } from "@reach/router"


export const CookieSettings = ({ data, dataLayer }) => {
  const cookieData = data
  const [checkNecessary, setCheckNecessary] = useState(true)
  const [checkAnalytical, setCheckAnalytical] = useState(false)
  const [checkStatistical, setCheckStatistical] = useState(false)
  const [checkSocial, setCheckSocial] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const isConsent = getCookieConsentValue()
    if (isConsent === "true") {
      document.documentElement.classList.remove("overflow-hidden")
    } else {
      document.documentElement.classList.add("overflow-hidden")
    }
  }, [])

  function removeOverflow() {
    const consentTrue = getCookieConsentValue()
    if (consentTrue === "true") {
      document.documentElement.classList.remove("overflow-hidden")
    }
  }

  const CookieOption = ({ check, setCheck, nameID, header, explainer }) => {
    return (
      <>
        <div className="my-4">
          <div className="flex">
            <input
              type="checkbox"
              name={nameID}
              id={nameID}
              checked={check}
              onChange={e => {
                setCheck(e.target.checked)
              }}
            />
            <label htmlFor={nameID}>
              <h3 className="font-sans font-medium text-xl text-black ml-4">
                {header}
              </h3>
            </label>
          </div>
          <RenderRichContent content={explainer} />
        </div>
      </>
    )
  }

  return (
    <CookieBanner
      disableStyles={true}
      disableButtonStyles={true}
      buttonClasses={styles.btn_consent}
      buttonWrapperClasses={styles.button_container}
      buttonText={cookieData.cookieAcceptButtonText}
      containerClasses={styles.cookie_setting_container}
      overlay={true}
      overlayClasses={"bg-gray-700/50 w-full h-full min-h-screen z-50 fixed"}
      onAccept={() => {
        if (
          checkAnalytical &&
          checkStatistical &&
          checkSocial &&
          checkNecessary
        ) {
          Cookies.set("gatsby-plugin-google-analytics", "true", {
            expires: 365,
          })
          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })
          dataLayer.push({ cookieType: "StatisticalCookies", consent: true })
          dataLayer.push({ cookieType: "AnalyticalCookies", consent: true })
          dataLayer.push({ cookieType: "SocialCookies", consent: true })
          dataLayer.push({ cookieType: "NecessaryCookies", consent: true })
          dataLayer.push({ event: "pageview" })
          initializeAndTrack(location)
          removeOverflow()
          return
        }
        if (checkAnalytical && checkStatistical && checkNecessary && !checkSocial) {

          Cookies.set("gatsby-plugin-google-analytics", "true", {
            expires: 365,
          })
          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })
          dataLayer.push({ cookieType: "StatisticalCookies", consent: true })
          dataLayer.push({ cookieType: "AnalyticalCookies", consent: true })
          dataLayer.push({ cookieType: "NecessaryCookies", consent: true })
          dataLayer.push({ event: "pageview" })
          initializeAndTrack(location)
          removeOverflow()
          return
        }
        if (checkAnalytical && checkSocial && checkNecessary && !checkStatistical) {


          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })

          dataLayer.push({ cookieType: "AnalyticalCookies", consent: true })
          dataLayer.push({ cookieType: "SocialCookies", consent: true })
          dataLayer.push({ cookieType: "NecessaryCookies", consent: true })
          dataLayer.push({ event: "pageview" })
          initializeAndTrack(location)
          removeOverflow()
          return
        }
        if (checkStatistical && checkSocial && checkNecessary && !checkAnalytical) {


          Cookies.set("gatsby-plugin-google-analytics", "true", {
            expires: 365,
          })
          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })

          dataLayer.push({ cookieType: "StatisticalCookies", consent: true })
          dataLayer.push({ cookieType: "SocialCookies", consent: true })
          dataLayer.push({ cookieType: "NecessaryCookies", consent: true })
          dataLayer.push({ event: "pageview" })
          initializeAndTrack(location)
          removeOverflow()
          return
        }
        if (checkStatistical && !(checkAnalytical & checkSocial)) {
          Cookies.set("gatsby-plugin-google-analytics", "true", {
            expires: 365,
          })
          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })
          dataLayer.push({ cookieType: "StatisticalCookies", consent: true })
          dataLayer.push({ cookieType: "NecessaryCookies", consent: true })

          dataLayer.push({ event: "pageview" })
        }
        if (checkAnalytical && !(checkStatistical && checkSocial)) {
          dataLayer.push({ cookieType: "AnalyticalCookies", consent: true })
          dataLayer.push({ cookieType: "NecessaryCookies", consent: true })
          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })

          dataLayer.push({ event: "pageview" })
        }
        if (checkSocial && !(checkAnalytical && checkStatistical)) {
          dataLayer.push({ cookieType: "SocialCookies", consent: true })
          dataLayer.push({ cookieType: "NecessaryCookies", consent: true })
          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })

          dataLayer.push({ event: "pageview" })
        }
        if (checkNecessary && !checkAnalytical && !checkSocial && !checkStatistical) {
          dataLayer.push({ cookieType: "NecessaryCookies", consent: true })
          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })

          dataLayer.push({ event: "pageview" })
        }
        initializeAndTrack(location)
        removeOverflow()
      }}
    >
      <div className={styles.setting_container}>
        <h2 className="font-sans text-2xl font-medium mt-0 mb-4">
          <RenderRichContent content={cookieData.titleChoice} />
        </h2>
        <RenderRichContent content={cookieData.cookiesExplainerOptions} />
        <form>
          <div className="my-4">
            <div className="flex">
              <input
                type="checkbox"
                name="necessary"
                id="necessary"
                disabled
                checked={checkNecessary}
              />
              <label>
                <h3 className="text-gray-500 cursor-pointer text-xl font-medium ml-4">
                  {cookieData.cookiesMandatoryHeader}
                </h3>
              </label>
            </div>
            <RenderRichContent
              content={cookieData.cookiesMandatoryExplainer}
            />
          </div>
          <CookieOption
            nameID={"analytical"}
            check={checkAnalytical}
            setCheck={setCheckAnalytical}
            header={cookieData.preferenceCookiesHeader}
            explainer={cookieData.preferenceCookiesExplainer}
          />
          <CookieOption
            check={checkStatistical}
            explainer={cookieData.statisticalCookiesExplainer}
            header={cookieData.statisticalCookiesHeader}
            setCheck={setCheckStatistical}
            nameID={"statistical"}
          />
          <CookieOption
            check={checkSocial}
            setCheck={setCheckSocial}
            nameID={"social"}
            header={cookieData.socialMediaCookiesHeader}
            explainer={cookieData.socialMediaCookiesExplainer}
          />
        </form>
      </div>
    </CookieBanner>
  )
}